export const spanDeCampoObrigatorio = (rules) =>{
    if (rules?.some(rule => rule.required)) {
        return <span style={{color: '#ff4d4f', fontFamily:'SimSun,sans-serif', marginInlineEnd:'4px'}}>*</span>;
    }
    return '';
}
export const styleCollapse = (hasError) => {
    let style = {}
    if (hasError) {
        style.borderBottom = '1px solid';
        style.borderColor = '#ff4d4f';
    }
    return style;
}